import { useState } from "react";
import { StandardButton } from "../../atoms/buttons";
import { Spinner } from "../../atoms/spinner";
import { TitleAtom } from "../../atoms/titleAtom";
import { ExpligoBadge } from "../expligobadge";
import { VerticalLayout } from "../layout";
import { is } from "date-fns/locale";
import I from "@editorjs/link";

export default function AssessmentStart({ elearningInformation, embedBtnState, startEmbedAssessment }) {
  const description = elearningInformation?.extra_description ? `${elearningInformation.extra_description}\n${elearningInformation.description || ""}` : elearningInformation?.description || "";
  const isMobile = window.innerWidth <= 768;
  const img = elearningInformation?.image_url || elearningInformation?.thumbnail_url || "/images/default-course-image.jpg";
  console.log(isMobile)
  return (
    <VerticalLayout className="complete-height dark-background">
      {isMobile ? (
          <>
            <img className="embed-background-image blur" src={img} alt={elearningInformation.title || "Cursus afbeelding"} />
            <img className="embed-background-image contain" src={img} alt={elearningInformation.title || "Cursus afbeelding"} />
          </>
        ) : (
          <img className="embed-background-image" src={img} alt={elearningInformation.title || "Cursus afbeelding"} />
        )}
      <div className="embed-background-overlay"></div>
      <div className="embed-thumbnail-bottom" style={{ justifyContent: isMobile ? "flex-end" : "flex-start" }}>
        <div className="bottom-text-container">
          <TitleAtom className={"bottom-text-title"} title={elearningInformation.title} />
          <CollapsibleText text={description} />
        </div>
        {/* <StandardButton style={{ marginLeft:"auto",  }} backgroundColor="white" textColor="standard-text-color" onClick={startEmbedAssessment} className={"button-embedcourse"} isDisabled={embedBtnState === 1}>
          {embedBtnState === 1 ? <Spinner color="grey-900" size="1.5rem" /> : "Starten"}
        </StandardButton> */}
          <StandardButton style={{ marginLeft:"auto", ...(!isMobile && { width: "10rem", height: "4rem", justifyContent: "center", padding: "2.5rem"})}} textColor="white" onClick={startEmbedAssessment} className={"button-embedcourse glass-btn"} isDisabled={embedBtnState === 1}>
          {embedBtnState === 1 ? <Spinner color="grey-900" size="1.5rem" /> : "Starten"}
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-play" viewBox="0 0 16 16" style={{ marginTop: "0.1rem" }}>
            <path d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"/>
          </svg>          
        </StandardButton>
      </div>
      <ExpligoBadge />
    </VerticalLayout>
  );
};

const CollapsibleText = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  const paragraphs = text.split(/\n+/).filter((p) => p.trim().length > 0);
  const isCollapsible = paragraphs.length > 1;
  const displayText = expanded || !isCollapsible
    ? paragraphs.map((p, i) => <span key={i}>{p}<br /></span>)
    : <span>{paragraphs[0]}...</span>;

  return (
    <div style={{ maxHeight: "10rem", overflowY: "auto" }}>
      <p className="bottom-text-subtitle">
        {displayText} {isCollapsible && (
          <StandardButton
            style={{ width: "unset", height: "unset", padding: 0, display: "inline" }}
            backgroundColor="transparent"
            textColor="primary-500"
            onClick={() => setExpanded(!expanded)}
            className="leesmeer-button no-margin"
            title={expanded ? "Lees minder" : "Lees meer"}
          />
        )}
      </p>
    </div>
  );
};



